















































import {Vue, Component, Prop} from 'vue-property-decorator';
import {Title} from '@/components/Title';
import {ApartmentsListTile} from '@/components/ApartmentsListTile';
import {ApartmentsListTileMobile} from '@/components';
import {SpecialOfferTile} from '@/components/SpecialOfferTile';
import {DashboardOneApartmentTile} from '@/components/DashboardOneApartmentTile';
import {mapActions, mapGetters} from 'vuex';
import { ProfileMemoType } from '@/types';
import ProfileMemoRules from './ProfileMemoRules';
import {hasPermissions} from '@/utils';

@Component({
  name: 'ProfileDashboard',
  components: {
    ApartmentsListTile, ApartmentsListTileMobile, DashboardOneApartmentTile,
    SpecialOfferTile, Title, ProfileMemoRules,
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
  },
  created() {
    if (hasPermissions('view_apartment', this.globalPermissions)) {
      this.fetchApartments();
    }
  },
  computed: {
    ...mapGetters('profile', ['dashboardTexts', 'myApartments', 'myApartmentsTexts']),
    ...mapGetters('user', ['loggedUser']),
    ...mapGetters('accounts', ['globalPermissions']),
    ...mapGetters(['paymentTexts']),
    actualListApartments() {
      if (this.myApartments.length > 0) {
        return this.myApartments.slice(0, 3);
      }
    },
    profileMemoType(): ProfileMemoType {
      if (!this.myApartments.length
        || (this.myApartments.length === 1 && (this as any).myApartments[0].user_role === 'future_renter')) {
        return 'FULL';
      }
      return 'SHORT';
    },
  },
  methods: {
    ...mapActions('profile', ['fetchApartments']),
    stringWithName(str) {
      return str.replace('%(name)s', this.loggedUser.first_name);
    },
  },
})
export default class ProfileDashboard extends Vue {}
